import { unixTimestamp } from '@scalar-org/entities/utility'
import { z } from 'zod'

export const tokenResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
})

/** Browser native JWT decoding. Returns null for invalid tokens */
export function decodeJwt(token: string): Record<string, any> | null {
  if (!token) return null

  const base64Url = token.split('.')[1]
  if (!base64Url) {
    return null
  }

  try {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    )

    return JSON.parse(jsonPayload)
  } catch (err) {
    console.error(err)
    return null
  }
}

/** Check if the token is expired or will expire in the next 60s */
export function isTokenExpired(
  token: string,
  /** current current time in unix milliseconds */
  current: number = Date.now(),
) {
  try {
    const data = decodeJwt(token)
    const exp = data?.exp || 0

    // We provide a little buffer in the event the refresh call takes longer than
    // expected or the interval needs to be fired a second time due to navigator.lock
    return exp < unixTimestamp(current) + 25
  } catch {
    return true
  }
}
